<template>
  <main class="mt-5 admin-slider">
    <div class="card mt-3">
      <div class="card-header  border-0">
        <h5 class="card-title font-bold">گروه های منو</h5>
      </div>
      <div class="card-body row">
        <template v-if="groups !== null">
          <router-link  :to="{name: 'menu' , params: {group: group.id}}" class="col-md-3 slider-group text-center ml-4" v-for="(group, index) in groups" :key="index">
            <h5 class="d-block my-3 font-bold">{{ groupLabels[index] ? groupLabels[index] : group.title }}</h5>
          </router-link>
        </template>
        <div v-else  class="d-flex justify-content-center w-100">
          <Loading/>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import MenuGroupImpl from '@@/core/pages/menu/MenuGroup/MenuGroupImpl'
export default {
  extends: MenuGroupImpl
}
</script>

<style scoped src="@@/core/pages/menu/MenuGroup/MenuGroupStyle.css"></style>
